import { useEffect, useState } from 'react'
import Tabs from '../../../../../../../modules/tabs/Tabs'
import TabDatosCliente from './TabDatosCliente'
import TabProductos from './TabProductos'
import TabReferencias from './TabReferencias'
import MinimalModal from './MinimalModal'
import { Button } from '../../../../../../ui'

export default function ModalEditarFactura({ open, onClose, documento, onSave }) {
  const [doc, setDoc] = useState(null)

  // Solo actualizamos el documento si existe. 
  // Si es null (al cerrar), mantenemos el anterior para que el modal no se quede vacío durante la animación.
  useEffect(() => {
    if (documento) {
      setDoc(JSON.parse(JSON.stringify(documento)))
    }
  }, [documento])

  // Solo retornamos null si no hay documento (evita el crash en el primer render)
  if (!doc) return null

  const tabs = [
    {
      title: 'Datos del Cliente',
      content: (
        <TabDatosCliente
          receiver={doc.document_receiver || {}}
        />
      )
    },
    {
      title: 'Productos',
      content: (
        <TabProductos
          details={doc.details || []}
          isExenta={String(doc?.dte_type?.code || '') === '34'}
          onChange={details => setDoc(prev => ({ ...prev, details }))}
        />
      )
    },
    {
      title: 'Referencias',
      content: (
        <TabReferencias
          references={doc.references || []}
          onChange={references => setDoc(prev => ({ ...prev, references }))}
        />
      )
    }
  ]

  return (
    <MinimalModal
      open={open}
      onClose={onClose}
      width={900}
      footer={
        <div className='flex items-center gap-3 px-2'>
          <Button
            onClick={onClose}
            className='h-9 px-6 text-[12px] font-medium bg-slate-100 text-slate-600 hover:bg-slate-200 transition-colors border-none shadow-none rounded-lg'
            title='Cerrar'
          />
          <Button
            className='h-9 px-6 text-[12px] font-semibold bg-primary text-white hover:opacity-90 transition-all shadow-sm shadow-primary/20 rounded-lg'
            title='Guardar Cambios'
            onClick={() => onSave(doc)}
          />
        </div>
      }
    >
      <div className='[&_.border-b-4]:border-b-2 [&_.text-lg]:text-base [&_.font-bold]:font-semibold [&_.text-primary]:text-slate-800 [&_.border-primary]:border-slate-800 transition-all'>
        <Tabs tabs={tabs} />
      </div>
    </MinimalModal>
  )
}
